import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { AppearCondition, AutocompleteCustomOption } from '../../../Forms/components/Autocomplete/autocomplete-custom-option.model';
import { ContentLibraryFolderService } from '../../../../Common/ContentLibrary/services/content-library-folder.service';
import { ContentLibraryFolderModel } from '../../../../Common/ContentLibrary/models/content-library-folder-model';

@Component({
    selector: 'agpr-library-selection-dialog',
    templateUrl: './library-selection-dialog.component.html',
    styleUrls: ['./library-selection-dialog.component.scss'],
    standalone: false
})
export class LibraryMoveDialogComponent extends AbstractDialogComponent implements OnInit {
    readonly buttonStyle = ButtonTypesEnum;

    @Input() groupOptions: Observable<ContentLibraryFolderModel[]>;
    @Output() dialogClose = new EventEmitter<ContentLibraryFolderModel>();
    @Output() dialogCancelled = new EventEmitter<void>();
    @Input() selectedItemsCount: number = 0;

    public selectedOption: ContentLibraryFolderModel;

    public autocompleteCustomOptions: AutocompleteCustomOption[] = [
        Object.assign(new AutocompleteCustomOption(), {
            label: 'Common.lhp.libraryMoveDialog.autocomplete.createLibrary',
            clearOnSelect: false,
            appearCondition: AppearCondition.noExactMatchInSuggestions,
            action: (name: string) => this.createNewLibrary(name)
        })
    ];

    constructor(
        public coreDialogService: CoreDialogService,
        private contentLibraryFolderService: ContentLibraryFolderService
    ) {
        super(coreDialogService, 'LibraryMove');
    }

    ngOnInit() {}

    createNewLibrary(name: string) {
        const library = new ContentLibraryFolderModel({ name });
        this.contentLibraryFolderService.createResource(library).subscribe({
            next: (newLibraryId) => {
                const newLibrary = new ContentLibraryFolderModel({ id: newLibraryId, name });
                this.contentLibraryFolderService.refreshAll();
                this.closeDialog(newLibrary);
            }
        });
    }

    cancel() {
        this.dialogCancelled.emit();
        this.coreDialogService.close(this.key);
    }

    ok() {
        this.closeDialog(this.selectedOption);
    }

    closeDialog(library: ContentLibraryFolderModel) {
        this.dialogClose.emit(library);
        this.coreDialogService.close(this.key);
    }
}
